export default "__VITE_ASSET__SN0Nvkud__"